module.exports = __webpack_public_path__ + "static/ig_banner_02-4bec6df0ea8be304b45c0daa8f824cc6.png";